import React from 'react';
import { cn } from '../../lib/utils';

const GlassCard = React.forwardRef(({ 
  className, 
  variant = 'default',
  hover = true,
  children, 
  ...props 
}, ref) => {
  const variants = {
    default: 'glass-card',
    light: 'glass-light rounded-2xl',
    medium: 'glass-medium rounded-2xl',
    heavy: 'glass-heavy rounded-2xl',
    gradient: 'gradient-card',
    feature: 'feature-card'
  };

  const hoverEffects = hover ? 'hover-lift' : '';

  return (
    <div
      ref={ref}
      className={cn(
        variants[variant],
        hoverEffects,
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
});

GlassCard.displayName = 'GlassCard';

export { GlassCard };
